import React from "react";
import { Alert, Snackbar } from "@mui/material";
import { SnackbarState } from "../../hooks/useSnackbar";

type AppSnackbarProps = {
  snackbar: SnackbarState;
  onClose: () => void;
  autoHideDuration?: number;
};

const AppSnackbar: React.FC<AppSnackbarProps> = ({
  snackbar,
  onClose,
  autoHideDuration = 4000,
}) => (
  <Snackbar
    open={snackbar.open}
    autoHideDuration={autoHideDuration}
    onClose={onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
  >
    <Alert severity={snackbar.severity} onClose={onClose} sx={{ width: "100%" }}>
      {snackbar.message}
    </Alert>
  </Snackbar>
);

export default AppSnackbar;
